import {Component, Inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MadeToOrderFabric} from "../../product-details/interface/made-to-order-fabric";
import {FabricProfileItemList} from "../../product-details/interface/fabric-profile-item-list";
import {CurrencyResolverService} from "../../currency-resolver.service";
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {FinishProfileItem} from "../../product-details/interface/finish-profile-item-list";
import {PipeModule} from "../../pipe/pipe.module";
import {ProductSkuComponent} from "../product-sku/product-sku.component";

@Component({
  selector: 'fb-product-custom-fabric-profile-dialog',
  standalone: true,
	imports: [CommonModule, PipeModule, MatDialogModule, ProductSkuComponent],
  templateUrl: './product-custom-fabric-profile-dialog.component.html',
  styleUrls: ['./product-custom-fabric-profile-dialog.component.scss']
})
export class ProductCustomFabricProfileDialogComponent {

	public selectedCurrency: ApCurrency = ApCurrency.INR;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {
			fabricProfileItemList: FabricProfileItemList[],
			madeToOrderFabric: MadeToOrderFabric,
			selectedFabric: FabricProfileItemList | undefined
		},
		private _currencyResolver: CurrencyResolverService,
		public dialogRef: MatDialogRef<ProductCustomFabricProfileDialogComponent>
	) {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});

		if(this.data.selectedFabric) {
			const index = this.data.fabricProfileItemList.findIndex(fabric => fabric.id === this.data.selectedFabric?.id);
			if (index !== -1) {
				this.data.fabricProfileItemList.unshift(...this.data.fabricProfileItemList.splice(index, 1));
			}
		}
	}
	public extractGSM(productName: string): number | null {
		const regex = /(\d+)\s*GSM/i;
		const match = productName.match(regex);
		return match ? parseInt(match[1], 10) : null;
	}

	public selectFabric(fabric: FabricProfileItemList | undefined): void {
		this.data.selectedFabric = fabric;
	}

	public onClose(proceed: boolean): void {
		if(proceed) {
			this.dialogRef.close(this.data.selectedFabric);
		}
		else
			this.dialogRef.close(undefined);
	}
}
